export const gradientStop = {
  type: 'object',
  properties: {
    offset: { type: 'number' },
    color: { type: 'string' },
    opacity: { type: 'number' },
  },
  additionalProperties: false,
} as const;

export const questionTheme = {
  type: 'object',
  properties: {
    name: { type: 'string' },
  },
  additionalProperties: false,
  required: ['name'],
} as const;

export const ratingSliderTheme = {
  ...questionTheme,
  properties: {
    ...questionTheme.properties,
    gradientStops: { type: 'array', items: gradientStop },
  },
} as const;
